import React, { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//UI
import { Typography, Grid, Paper, Button, IconButton } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assets/icons/svg/search.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/svg/trash.svg";
//Components
import PantrySection from "./PantrySection";
import Spinner from "../layout/Spinner";

//Actions
import {
  fetchPantryLocations,
  openAddItemModal,
  closeAddItemModal,
  resetPantryState,
  closeItemModal,
} from "../../actions/pantry";
//Modals
import CustomModal from "../modal/CustomModal";
import ComingSoonModal from "../comingsoon/ComingSoonModal";
import InitialAddItem from "./modals/add_items/Initial";
import PantryItemModal from "./modals/info/PantryItemModal";

const PantryHome = ({
  pantry: { locations, modals, locationItems, item },
  fetchPantryLocations,
  fetchLocationItems,
  auth: { user },
  openAddItemModal,
  closeAddItemModal,
  resetPantryState,
  closeItemModal,
}) => {
  //Get pantry locations
  useEffect(() => {
    fetchPantryLocations();
  }, []);

  //Modal State
  const [showSelectedOptions, setShowSelectedOptions] = useState(false);
  const [numSelected, setNumSelected] = useState(0);
  const handleAddToSection = (location) => {
    openAddItemModal({ location });
  };

  const handleExit = () => {
    closeAddItemModal();
  };

  const navigate = useNavigate();
  const handleCloseComingSoon = () => {
    navigate("/");
  };

  const checkShowSelectedOptions = () => {
    let selectedCount = 0;

    const countSelectedItems = (section) => {
      for (let i = 0; i < locations[section].items.length; i++) {
        if (locations[section].items[i].selected) {
          selectedCount++;
        }
      }
    };

    // Count selected items in each section
    if (locations && locations?.items) {
      countSelectedItems("fridge");
      countSelectedItems("pantry");
      countSelectedItems("freezer");
      countSelectedItems("spicerack");

      if (selectedCount > 0) {
        setShowSelectedOptions(true);
        setNumSelected(selectedCount);
        return { show: true, value: selectedCount };
      } else {
        setShowSelectedOptions(false);
        setNumSelected(0);
        return { show: false, value: 0 };
      }
    }
    setShowSelectedOptions(false);
    setNumSelected(0);
    return { show: false, value: 0 };
  };

  useEffect(() => {
    checkShowSelectedOptions();
  }, [locations]);

  useEffect(() => {
    return () => {
      resetPantryState();
    };
  }, []);

  return (
    <div className="min-h-[100vh] bg-neutral-50">
      <CustomModal
        open={!(user && user.isAdmin)}
        showExit={false}
        handleClose={handleCloseComingSoon}
        rounded="rounded-2xl"
        border={false}
        type="bottom"
        parentClassNameOverride="md:min-w-[600px]"
      >
        <ComingSoonModal />
      </CustomModal>
      <CustomModal open={modals?.add?.open} handleClose={handleExit} border={false} type="bottom">
        <InitialAddItem />
      </CustomModal>
      <CustomModal open={item?.open} handleClose={() => closeItemModal()} type="bottom">
        <PantryItemModal />
      </CustomModal>
      <div className="py-[4rem] md:py-0 md:pl-[5rem]">
        <div className="md:p-8">
          <div className="grid grid-cols-1 gap-y-4 xl:grid-cols-2 lg:gap-4 mb-[3rem]">
            {locations.loading ? (
              <Spinner />
            ) : locations.error ? (
              <Typography>{locations.error}</Typography>
            ) : locations && locations.data && locations.data.length > 0 ? (
              <>
                {locations.data.map((location) => (
                  <PantrySection key={location._id} location={location} title={location.name} />
                ))}
              </>
            ) : (
              <Typography className="text-secondaryText">No locations found.</Typography>
            )}
          </div>
        </div>
      </div>
      {showSelectedOptions && (
        <div className="fixed w-screen bottom-0 py-2 bg-neutral-500/20 backdrop-blur-[2px] mb-[4rem] md:mb-0 z-20">
          <div className="flex flex-row gap-2 justify-center md:pl-[5rem]">
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon className="h-4 w-auto fill-background" />}
            >
              Search for Recipes
            </Button>

            <Button
              variant="contained"
              color="secondary"
              className="bg-background hover:bg-neutral-100 border border-primaryText-300 hover:border-primaryText-600 min-w-fit"
            >
              <TrashIcon className="h-4 w-auto fill-primaryText" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

PantryHome.propTypes = {
  pantry: PropTypes.object.isRequired,
  fetchPantryLocations: PropTypes.func.isRequired,
  resetAddPantry: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  openAddItemModal: PropTypes.func.isRequired,
  closeAddItemModal: PropTypes.func.isRequired,
  resetPantryState: PropTypes.func.isRequired,
  closeItemModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  fetchPantryLocations,
  openAddItemModal,
  closeAddItemModal,
  resetPantryState,
  closeItemModal,
})(PantryHome);
